
interface Country {
    country: string,
    code: string,
    alpha_2_code: string,
    [propName: string]: any
}

export default class CountryMapper {

    readonly countryList:Array<Country>

    constructor(countryList: Array<Country>) {
        this.countryList = countryList || []
    }

    public getCountryBy2DigitCode(code: string): Country | null {
        return this.countryList.find(c => c.alpha_2_code === code) || null;
    }

    public getCountryBy3DigitCode(code: string): Country | null {
        return this.countryList.find(c => c.code === code) || null;
    }

    public swapCode(code: string): string | null {
        let is3Digit = code.length === 3;
        let key = is3Digit ? 'alpha_2_code' : 'code'
        let country = is3Digit ?
            this.getCountryBy3DigitCode(code):
            this.getCountryBy2DigitCode(code)
        return country ? country[key] : null;
    }
}
